module.exports = __webpack_public_path__ + "img/crm2back.462bfe94.png";